<template>
  <div class="DDesign">
    <div class="inner_center">
      <h2 class="headline">为什么选择我们的3D设计</h2>

      <div class="content">
        <div class="swiper-wrap">
          <div
            v-swiper:mySwiper2="swiperOption2"
            class="swiper swiper2">
            <div class="swiper-wrapper">
              <div
                v-for="vo in banner"
                :key="vo.id"
                class="swiper-slide _pointer"
              >
                <img
                  :src="vo.link"
                  class="swiper-img">
              </div>
            </div>
          </div>
        </div>
        <div class="intro-list">
          <div
            class="intro-item "
            :class="{ 'ON' : idx == swiperOption2.initialSlide }"
            v-for="(vo,idx) in banner"
            :key="vo.id"
            @mouseover="toggleSwiper(idx)"
            @click.stop="toggleSwiper(idx)"
          >
            <i :class="'icon_' + (idx+1)" class="icon"></i>
            <span class="name">{{ vo.label }}</i></span>
            <i :class="'badge_' + (idx+1)" class="badge"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {fnLocalStorage, fnLogin} from "@/fn";
import {MODEL_INTRODUCE_DIALOG} from "@/constant/MODELS";

export default {
  name: "DDesign",
  data(){
    return{
      isShow: false,
      banner:[
        {
          id: 0,
          link:'//js.chaopx.com/chaotu/3d/design/design%40case1.png',
          label: '3D人物绑定骨骼，动作状态轻松调整',
        },
        {
          id: 1,
          link:'//js.chaopx.com/chaotu/3d/design/design%40case2.png',
          label: '3D场景原创建模，灵活可修改度高',
        },
        {
          id: 2,
          link:'//js.chaopx.com/chaotu/3d/design/design%40case3.png',
          label: '高质量打光渲染，精细化材质贴图效果逼真',
        },
        {
          id: 3,
          link:'//js.chaopx.com/chaotu/3d/design/design%40case4.png',
          label: '素材文件完整，渲染器、环境、材质保存完整',
        }
      ],
      swiperOption2: {
        autoplay: {
          delay: 5000,
          speed: 500,
          disableOninteraction: true
        },
        effect: 'fade',
        fade:{
          crossFade:true  //开启淡出。过渡时，原slide透明度从1->0（淡出），过渡中的slide透明度从0->1（淡入），其他slide透明度0。
          //false  关闭淡出。过渡时，原slide透明度为1（不淡出），过渡中的slide透明度从0->1（淡入），其他slide透明度0。
        },
        //配置分页
        pagination: {
          el: '.swiper-pagination'//分页的dom节点
        },
        direction: "vertical",
        initialSlide: 0, // 默认选中
        loop: true, // 在此无效？？？？？
        centeredSlides: true, //活动块居中
        slideToClickedSlide: false, // 点击切换
        lazy: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiper2");
            // this.swiperOption2.initialSlide = c_swiper[0].swiper.activeIndex - 1;
            console.log("轮播图滚动事件 --->",c_swiper[0].swiper.activeIndex-1)
            if (c_swiper[0].swiper.activeIndex - 1 >  this.banner.length-1){
              this.swiperOption2.initialSlide = 0
            }else {
              this.swiperOption2.initialSlide = c_swiper[0].swiper.activeIndex -1;
            }
           /* if (c_swiper[0].swiper.activeIndex - 1 <  0){
              this.swiperOption2.initialSlide = this.banner.length-1
            }*/
            // console.log("轮播图滚动事件 --->",c_swiper[0].swiper.activeIndex)
            // console.log("轮播图滚动事件 --->",this.swiperOption2.initialSlide)
          }
        }
      },
    }
  },
  methods:{
    toggleSwiper(index) {
      console.log(index)
      if (index > this.banner.length-1){
        index = 0
      }
      if (index < 0){
        index = this.banner.length-1;
      }

      // this.calendarMenuIndex = index;
      this.swiperOption2.initialSlide = index;
      console.log(this.swiperOption2.initialSlide)

      if (process.client) {
        this.mySwiper2.slideTo(index + 1, 1000);
        // this.mySwiper2.slideTo(index, 1000);
      }
    },

    closeDialog(){
      this.isShow = false;
      this.$store.commit('base/SET_INTRODUCE_DIALOG', false);
      fnLocalStorage.setItemDate(MODEL_INTRODUCE_DIALOG,1)
    },

    showLoginDialog(){
      this.closeDialog();
      fnLogin.listenPageStart(this.$store)
    }
  }
}
</script>

<style lang="scss" scoped>
.DDesign{
  @include BgImage(100%,760px,'3d/design-bg.jpg',1);
  position: relative;
  z-index: 20;
  .inner_center{
    //padding-right: 18px;
    box-sizing: border-box;

    .headline{
      font-size: 44px;
      font-weight: bold;
      color: #21222E;
      line-height: 59px;
      letter-spacing: 1px;
      text-align: center;
      margin: 72px 0 64px;
    }

    >.content{
      display: flex;
      //justify-content: space-between;
    }

    .swiper-wrap{
      width: 722px;
      height: 470px;
      //border-radius: 100px 14px 14px 14px;
      position: relative;
      margin-right: 200px;
      flex-shrink: 0;

      .swiper{
        width: 100%;
        height: 100%;
        border-radius: 14px;
      }

      .swiper-pagination1{
        z-index: 10;
        @include Position(1,3,-22px,24px);
        display: flex;
        flex-direction: column;

        .swiper-pagination-bullet{
          width: 6px;
          height: 6px;
          background: #cccccc;
          margin-bottom: 4px;
          transition: all 0.5s ease;
          cursor: pointer;

          &:last-child{
            margin-bottom: 0 !important;
          }
        }

        .swiper-pagination-bullet-active{
          width: 6px;
          height: 18px;
          background: #E0E3E9;
          border-radius: 4px;
        }
      }

      img{
        width: 100%;
        height: 100%;
      }
    }

    .intro-list{
      display: flex;
      flex-direction: column;
      margin-top: 72px;
      .intro-item{
        border-radius: 8px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.5s ease;
        width: 500px;
        height: 68px;
        line-height: 68px;
        margin-bottom: 32px;
        @include BgImage(500px,68px,'3d/design-bar.png');
        position: relative;
        padding-left: 51px;
        box-sizing: border-box;

        &:last-child{
          margin-bottom: 0;
        }

        &.ON{
          font-weight: 600;
          @include BgImage(500px,68px,'3d/design-bar@active.png');

          >.badge{
            display: block !important;
          }

          .name{
            font-size: 20px;
          }
        }


        /*.icon_cur{
          @include BgImage(17px,17px,'common/dialog/introduce-dialog/icon%40shou.png');
          transition: all 0.5s ease;
          margin: 0 12px;
        }*/

        .name{
          font-size: 19px;
          color: #2D2B33;
          letter-spacing: 1px;

          i{
            font-weight: bold;
            margin-left: 4px;
          }
        }
        >i{
          &.icon{
            @include Position(1,5,0,54%);
            transform: translateY(-50%);
            &.icon_1{
              @include BgImage(43px,60px,'3d/design-bar%40icon1.png');
              left: -36px !important;
            }
            &.icon_2{
              @include BgImage(67px,54px,'3d/design-bar%40icon2.png');
              left: -50px !important;
            }
            &.icon_3{
              @include BgImage(50px,59px,'3d/design-bar%40icon3.png');
              left: -40px !important;
            }
            &.icon_4{
              @include BgImage(44px,50px,'3d/design-bar%40icon4.png');
              left: -36px !important;
            }
          }

          &.badge{
            @include Position(1,2,-4px,-12px);
            display: none !important;
            &.badge_1{
              @include BgImage(201px,28px,'3d/design-badge1.png');
            }
            &.badge_2{
              @include BgImage(201px,28px,'3d/design-badge2.png');
            }
            &.badge_3{
              @include BgImage(201px,28px,'3d/design-badge3.png');
            }
            &.badge_4{
              @include BgImage(201px,28px,'3d/design-badge4.png');
            }
          }

        }
      }
    }
  }


  @include Screen(1){
    @include BgImage(100%,707px,'3d/design-bg.jpg',1);
    .inner_center{
      .swiper-wrap{
        width: 586px;
        height: 381px;
        margin-right: 114px;
      }
      .intro-list{
        margin-top: 37px;
        .intro-item{
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
